import { Textarea } from '@/components/form';
import * as React from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface OpenQuestionI {
	index: number;
	register: UseFormRegister<FieldValues>;
}

export const OpenQuestion: React.FC<OpenQuestionI> = ({ index, register }) => {
	return (
		<>
			<Textarea
				name={`questions[${index}].expected_answer`}
				id={`questions[${index}].expected_answer`}
				register={register}
				placeholder="Write your answer here"
				disabled
				classNameInput="disabled:bg-white disabled:placeholder-opacity-primary"
			/>
		</>
	);
};
